import ContactIdMappingListResourceModel from '../../generated/types/model/resource/ContactIdMappingListResourceModel';

export default class ContactIdMappingListResourceViewModel extends ContactIdMappingListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
